import { gql } from '@apollo/client';

import type * as GraphQLTypes from '../../../../graphql/types.generated';
export type UpdateWebhookMutationVariables = GraphQLTypes.Exact<{
  input: GraphQLTypes.UpdateWebhookInput;
}>;

export type UpdateWebhookMutationResult = { __typename?: 'Mutation' } & {
  webhookSubscriptionsUpdateWebhook?: GraphQLTypes.Maybe<
    { __typename?: 'UpdateWebhookPayload' } & {
      errors?: GraphQLTypes.Maybe<Array<{ __typename?: 'Error' } & Pick<GraphQLTypes.Error, 'message' | 'path'>>>;
    }
  >;
};

export const UpdateWebhookDocument = gql`
  mutation updateWebhook($input: UpdateWebhookInput!) {
    webhookSubscriptionsUpdateWebhook(input: $input) {
      errors {
        message
        path
      }
    }
  }
`;
